import { posterMap } from "@/pages/poster/js/poster-static";
export const poster = {
  namespaced: true,
  state: {
    // 设计数据
    posterData: JSON.parse(JSON.stringify(posterMap)),
    // 最终生成的封面列表
    posterDataList: [],
  },
  mutations: {
    // 更新posterData
    updatePosterData(state, map) {
      if (map.params && map.data) {
        Object.assign(map.data, map.params);
        return;
      }
      Object.assign(state.posterData, map);
    },
    // 更新posterDataList的数量
    updatePosterDataList(state, map) {
      if (Array.isArray(map)) {
        state.posterDataList = map;
      } else {
        // 更新posterDataList每一项的属性
        state.posterDataList.forEach(poster => {
          Object.assign(poster, map);
        });
      }
    },
    // 更新posterDataList的某一项
    updatePosterDataListItem(state, { index, params }) {
      if (index !== -1) {
        Object.assign(state.posterDataList[index], params);
      }
    },
    // 删除posterDataList的某一项
    deletePosterData(state, index) {
      state.posterDataList.splice(index, 1);
    },
    // 清除缓存的数据
    clearPosterCacheInfo(state) {
      state.posterData = JSON.parse(JSON.stringify(posterMap));
      state.posterDataList = [];
    },
  },
};
